import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { FAQ } from "../mock";
import Reveal from "./Reveal";

const FaqSection = () => {
  return (
    <section id="faq" className="relative py-20 lg:py-28 bg-[#0A1220]">
      <div className="max-w-3xl mx-auto px-5 lg:px-8">
        <Reveal className="mb-10">
          <p className="text-[13px] font-semibold tracking-wide text-[#13D99A] uppercase mb-4">FAQ</p>
          <h2 className="font-display text-3xl lg:text-5xl font-bold text-[#F5F7FB] leading-[1.08]">
            Questions, answered.
          </h2>
        </Reveal>

        <Reveal delay={80}>
          <Accordion type="single" collapsible className="space-y-3">
            {FAQ.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="rounded-xl border border-[#29354A] bg-[#121A28] px-5 data-[state=open]:border-[#10C98A]/40"
              >
                <AccordionTrigger className="text-left text-[#F5F7FB] font-medium hover:no-underline py-5">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#8290A8] leading-relaxed pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};

export default FaqSection;
